function numberToChinese(num: number) {
  const chars = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const units = ['', '十', '百', '千', '万']

  if (num < 10) return chars[num] // 0-9 直接返回
  if (num < 20) return num === 10 ? '十' : '十' + chars[num % 10] // 10-19 处理

  let result = ''
  const strNum = String(num)
  const len = strNum.length

  for (let i = 0; i < len; i++) {
    const n = +strNum[i]
    if (n !== 0) {
      result += chars[n] + units[len - i - 1]
    } else if (!result.endsWith('零') && i !== len - 1) {
      result += '零'
    }
  }

  return result.replace(/零+$/, '').replace(/^一十/, '十') // 去掉多余零，修正"一十"
}

export function generateChineseArray(length: number) {
  return Array.from({ length }, (_, i) => numberToChinese(i + 1))
}
